import React from 'react';
import { useUser } from '../context/UserContext';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const { userData } = useUser();
  
  // 🔥 VERIFICAÇÃO EM TEMPO REAL - ATUALIZADA PARA OS NOVOS PLANOS
  const isPremiumUser = userData?.plan === 'premium' || userData?.plan === 'prem' || userData?.plan === 'mensal' || userData?.plan === 'anual';

  // CONTEÚDO PARA USUÁRIOS PREMIUM - MAIS SIMPLES
  if (isPremiumUser) {
    return (
      <div className="home-container">
        <section className="premium-home-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                <div className="premium-status-badge">
                  ⭐ USUÁRIO PREMIUM
                </div>
                <h1 className="welcome-title">
                  Bem-vindo de volta!
                </h1>
                <p className="welcome-subtitle">
                  Você tem acesso completo a todas as estratégias avançadas.
                </p>
                
                <div className="premium-quick-actions">
                  <Link to="/8-7" className="action-btn primary">
                    🚀 Usar Estratégia 8-7
                  </Link>
                  <Link to="/surpresinha" className="action-btn secondary">
                    🎲 Surpresinha Premium
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  // CONTEÚDO PARA USUÁRIOS FREE - ATUALIZADO COM NOVOS PLANOS
  return (
    <div className="home-container">
      {/* Hero Section para Free Users */}
      <section className="hero-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 text-center">
              <h1 className="hero-title">
                Domine a Lotofácil com 
                <span className="gradient-text"> Inteligência Matemática</span>
              </h1>
              
              <p className="hero-subtitle">
                Gere jogos estratégicos baseados na estatística par-ímpar e 
                <strong> aumente suas chances em até 3.787x</strong>
              </p>

              {/* Banner de Upgrade Atualizado */}
              <div className="cta-banner">
                <div className="cta-content">
                  <span className="cta-badge">🎯 MÉTODO COMPROVADO</span>
                  <h4>
                    Escolha seu plano Premium
                  </h4>
                  <div className="plan-options">
                    <div className="plan-option">
                      <span className="plan-name">Mensal</span>
                      <span className="plan-price">R$ 39,90/mês</span>
                      <small>Flexibilidade total</small>
                    </div>
                    <div className="plan-option featured">
                      <span className="plan-name">Anual</span>
                      <span className="plan-price">R$ 197,90/ano</span>
                      <small>Economize R$ 160,90</small>
                    </div>
                  </div>
                  <p className="price-equivalent">
                    <strong>Equivale a apenas R$ 16,49 por mês</strong>
                  </p>
                </div>
                <Link to="/upgrade" className="cta-button">
                  QUERO SER PREMIUM AGORA
                </Link>
              </div>

              {/* Estatísticas Rápidas */}
              <div className="quick-stats">
                <div className="stat-item">
                  <div className="stat-number">1.247+</div>
                  <div className="stat-label">Usuários Premium</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">97%</div>
                  <div className="stat-label">Taxa de Satisfação</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">7 dias</div>
                  <div className="stat-label">Garantia</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Seção de Recursos Free */}
      <section className="features-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="feature-card">
                <div className="feature-icon">🔢</div>
                <h3>Estratégia 7-8</h3>
                <p>
                  Acesso gratuito à estratégia básica 7-8 (Par-Ímpar). 
                  <strong> Gere até 7 jogos por dia</strong> e experimente o poder da análise matemática.
                </p>
                <Link to="/7-8" className="feature-link">
                  Experimentar Agora →
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="feature-card premium-feature">
                <div className="feature-icon">🚀</div>
                <h3>Estratégias Avançadas</h3>
                <p>
                  <strong>Desbloqueie 5 estratégias premium:</strong> 8-7, 6-9, 9-6, 5-10, 10-5. 
                  Gere jogos ilimitados e maximize suas chances.
                </p>
                <Link to="/upgrade" className="feature-link premium">
                  Desbloquear Premium →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Seção de Comparação */}
      <section className="comparison-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2>Por que ser Premium?</h2>
              <div className="comparison-grid">
                <div className="comparison-item">
                  <h4>👶 Free</h4>
                  <ul>
                    <li>1 estratégia básica</li>
                    <li>7 jogos por dia</li>
                    <li className="missing">Estratégias avançadas ❌</li>
                    <li className="missing">Surpresinha ❌</li>
                    <li className="missing">Suporte prioritário ❌</li>
                  </ul>
                </div>
                <div className="comparison-item featured">
                  <div className="popular-badge">🔥 RECOMENDADO</div>
                  <h4>👑 Premium</h4>
                  <ul>
                    <li>6 estratégias completas</li>
                    <li>Jogos ilimitados</li>
                    <li>Surpresinha inteligente ✅</li>
                    <li>Suporte VIP ✅</li>
                    <li>Atualizações constantes ✅</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Chamada Final para Ação */}
      <section className="final-cta-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 text-center">
              <h2>Pronto para elevar seu jogo?</h2>
              <p>
                Junte-se aos <strong>1.247 usuários</strong> que já estão usando 
                as estratégias avançadas do Lotopim.
              </p>
              <Link to="/upgrade" className="final-cta-button">
                🚀 QUERO ACESSO PREMIUM AGORA
              </Link>
              <div className="guarantee-note">
                ✅ <strong>Garantia de 7 dias</strong> - Se não gostar, devolvemos seu dinheiro
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;